import { useNavigate } from '@tanstack/react-router';
import { Database, Users } from 'lucide-react';
import { AgroPipeCard } from './AgroPipeCard';

// Tela 00 · Agronomia (seleção · desktop) — entrada do módulo em pipes no padrão
// dos cards de destaque do CRM (92×88, icon box coral, alinhado à esquerda).
// Mobile NÃO passa por aqui (cai direto em Produtores — fluxo do APK preservado).
export function SelecaoAgronomiaView() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col bg-bg px-8 pb-8 pt-7">
      <h1 className="text-[18px] font-semibold leading-6 text-text">Agronomia</h1>
      <span className="text-sm text-text-2">Selecione a área de trabalho</span>

      <div className="flex flex-wrap gap-3.5 pt-6">
        <AgroPipeCard
          titulo="Produtores"
          icone={<Users size={14} strokeWidth={1.7} />}
          onClick={() => void navigate({ to: '/agronomia/produtores' })}
        />
        <AgroPipeCard
          titulo="Bancos de Dados"
          icone={<Database size={14} strokeWidth={1.7} />}
          onClick={() => void navigate({ to: '/agronomia/bancos-de-dados' })}
        />
      </div>
    </div>
  );
}
